import React from 'react';
import { IconProps } from './model/IconInterface';

const ClockIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <circle cx='12' cy='12' r='9' />
        <polyline points='12 7 12 12 15 14' />
    </svg>
);

export default ClockIcon;
